

$(function () {
  $('.jsSeminerInfoContentsBtn').on('click', function(){
    $('.jsSeminarInfoConfirmDialog').hide();
    $('.jsSeminarInfoContentsArea').show();
  })
})
